<template>
    <v-card variant="flat"
            class="mx-7 mt-3 text-center"
            color="grey-lighten-4">
        <template v-slot:text>
            <small><v-icon icon="mdi-package-variant-closed"></v-icon> STOCK LEVEL</small>
            <h1>{{ level }}</h1><small> KGS</small>
            <div v-if="onOrder">
                <small><v-icon icon="mdi-package-variant-closed-plus"></v-icon> ON-ORDER</small>
                <h3>{{ onOrder }}<small> KGS</small></h3>
            </div>
        </template>
    </v-card>
</template>
<style scoped>

</style>
<script>
    function initialState() {
        return {
            loading: false
        };
    }
    export default {
        name: "StockLevel",
        data: function () {
            return initialState();
        },
        mounted: function () {
        },
        props: {
            level: Number,
            onOrder: Number
        },
        methods: {
        },
        computed: {
        }
    };
</script>